<template>
  <b-row>
    <b-col>
      <div class="note-pre-loader" v-if="preLoadingNotes"></div>
      <div
        v-else-if="noNotes"
        class="no-content-holder"
        :style="{ 'background': 'url(' + noContentIcon + ') no-repeat center center /contain'}"
      ></div>
      <b-row
        lg="12"
        v-for="(note, index) in allNotes"
        :key="note._id"
        class="note-container play-shadow"
      >
        <b-col>
          <b-row v-if="note.loading">
            <ContentLoader style="height:200; width:540">
              <rect x="7" y="6" rx="3" ry="3" width="230" height="25" />
              <rect x="7" y="65" rx="0" ry="0" width="310" height="10" />
              <rect x="7" y="48" rx="0" ry="0" width="230" height="10" />
            </ContentLoader>
          </b-row>
          <b-row v-else v-on:click="noteClicked($event, note)">
            <div class="listing-note">
              <p class="moow-header-2">{{note.title}}</p>
              <p class="moow-info-txt">{{note.body}}</p>
            </div>
          </b-row>
          <!-- md-fab md-accent md-flat -->
          <div v-if="userRoleCanEditNotes">
            <md-button
              v-if="note._id && !note.loading"
              class="delete-note md-dense md-primary md-icon-button"
              @click="confirmDeleteNote($event, note, index)"
            >
              <md-icon>delete</md-icon>
            </md-button>
            <img v-else :src="loaderRolling" class="delete-note mo-btn-mini" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <md-button
            @click="createNewNote"
            :disabled="disableNewNote"
            class="md-fab"
            style="float:right">
            <md-icon>add</md-icon>
          </md-button>
        </b-col>
      </b-row>
    </b-col>

    <md-dialog
      :md-active.sync="showDialog"
      style="min-width:90vw"
      :md-click-outside-to-close="false"
    >
      <b-form-textarea
        class="note-content note-title-area"
        v-model="selectedNote.title"
        placeholder="Title"
        :rows="1"
        :max-rows="1"
      ></b-form-textarea>

      <b-form-textarea
        class="note-content note-body-area"
        v-model="selectedNote.body"
        placeholder="Enter something"
      ></b-form-textarea>
      <!-- <md-dialog-title>
        <md-input class="note-content note-title-area"
            v-model="selectedNote.title"
          placeholder="Title">
        </md-input>
      </md-dialog-title>

      <md-content>
      <md-field>
        <md-textarea v-model="selectedNote.body" required></md-textarea>
      </md-field>
      </md-content>-->

      <md-dialog-actions>
        <span
          v-if="!selectedNote.isNew"
          class="note-last-update"
        >Last updated {{selectedNoteFormatedUpdatedAt}}</span>
        <md-button class="md-primary" @click="closeNote">Cancel</md-button>
        <md-button class="md-primary" @click="saveNote" style="color:#0069D9">Save</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-snackbar
      md-position="center"
      :md-duration="Infinity"
      :md-active.sync="showNoteDeleteSnackbar"
      md-persistent
    >
      <span>Delete Note?</span>
      <md-button class="md-primary" @click="cancelDeleteNote">Cancel</md-button>
      <md-button class="md-accent md-raised" @click="deleteSelectedNote">Delete</md-button>
    </md-snackbar>
  </b-row>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
import { formatToDynamicTime } from "../functions.js";
import { uploadNote, getNotesForDeal } from "../dealNotesRepository.js";

export default {
  props: {
    dealId: {
      type: String | Number,
      required: true
    },
    accountId: {
      type: String | Number,
      required: true
    }
  },
  components: {
    ContentLoader
  },
  data() {
    return {
      showDialog: false,
      showNoteDeleteSnackbar: false,
      deletableNote: undefined,
      deletableNoteIndex: -1,
      allNotes: [],
      selectedNote: Object,
      preLoadingNotes: false,
      disableNewNote: false
    };
  },
  computed: {
    currentUserRole() {
      return this.$store.getters.userRoleInAccount;
    },
    userRoleCanEditNotes() {
      if (!this.currentUserRole) return false;
      else if (
        this.$store.getters.accountWriteRoles.includes(this.currentUserRole)
      )
        return true;
      return false;
    },
    noContentIcon() {
      return require("../assets/no_content.svg");
    },
    selectedNoteFormatedUpdatedAt() {
      return formatToDynamicTime(this.selectedNote.updatedAt);
    },
    noNotes() {
      return this.allNotes.length == 0;
    },
    loaderRolling() {
      return require("../assets/loader-rolling.svg");
    }
  },
  created() {
    this.loadAllNotesFromServer();
  },
  methods: {
    async loadAllNotesFromServer() {
      try {
        if (!this.dealId || !this.accountId) {
          return;
        }
        this.preLoadingNotes = true;
        const notes = await getNotesForDeal(this.dealId, this.accountId);
        if (!Array.isArray(notes)) {
          return;
        }
        sessionStorage.setItem("loadNotesFromStorage", true);
        this.allNotes = this.orderNotes(notes);
        sessionStorage.setItem("listingNotes", JSON.stringify(this.allNotes));
      } catch (error) {
        this.notifyError("Something is not right", "cannot get notes");
      } finally {
        this.preLoadingNotes = false;
      }
    },
    noteClicked(event, note) {
      this.selectedNote = note;
      this.showDialog = true;
    },
    saveNote() {
      if (!this.dealId || !this.accountId) {
        return;
      }
      if (!this.selectedNote.title || !this.selectedNote.body) {
        this.showDialog = false;
        return;
      }
      this.disableNewNote = true;
      this.selectedNote.updatedAt = new Date().toISOString();
      var isNewNote = this.selectedNote.isNew;
      if (isNewNote) {
        this.selectedNote.isNew = false;
        this.allNotes.unshift(this.selectedNote);
      } else {
        var notesTemp = this.allNotes;
        this.allNotes = this.orderNotes(notesTemp);
      }
      uploadNote(this.selectedNote, this.dealId, this.accountId).then(resp => {
        if (isNewNote) Vue.set(this.allNotes, 0, resp); //newest will be first after orderNotes()
        this.disableNewNote = false;
      });
      //TODO: get back note ID or entire note and add id / replace with the one in the list
      this.showDialog = false;
    },
    closeNote() {
      this.showDialog = false;
    },
    createNewNote() {
      this.selectedNote = {
        title: "",
        body: "",
        createdAt: new Date(),
        updatedAt: new Date(),
        isNew: true,
        archived: false
      };
      this.showDialog = true;
    },
    confirmDeleteNote(event, note, index) {
      this.showNoteDeleteSnackbar = true;
      this.deletableNote = note;
      this.deletableNoteIndex = index;
    },
    cancelDeleteNote() {
      this.showNoteDeleteSnackbar = false;
      this.deletableNoteIndex = -1;
      this.deletableNote = undefined;
    },
    deleteSelectedNote() {
      if (!this.dealId || !this.accountId) {
        return;
      }
      if (this.deletableNoteIndex > -1 && this.deletableNote) {
        this.deletableNote.archived = true;
        uploadNote(this.deletableNote, this.dealId, this.accountId);
        Vue.delete(this.allNotes, this.deletableNoteIndex);

        this.deletableNoteIndex = -1;
        this.deletableNote = undefined;
      }
      this.showNoteDeleteSnackbar = false;
    },
    orderNotes(notes) {
      function compare(a, b) {
        const noteA = a.updatedAt;
        const noteB = b.updatedAt;

        let comparison = 0;
        if (noteA < noteB) {
          comparison = 1;
        } else if (noteA > noteB) {
          comparison = -1;
        }
        return comparison;
      }
      return notes.sort(compare);
    },
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    }
  }
};
</script>
<style scoped>
@import "../assets/styles/listing-notes.css";
@import "../assets/styles/global.css";

.no-content-holder {
  height: 100px;
  background-size: contain;
}

.note-container {
  margin: 0 auto;
  padding: 1em;
  border-radius: 10px;
  background-color: white;
  cursor: pointer;
  margin-bottom: 1em;
  max-height: 200px;
}
.listing-note {
  overflow: hidden;
}

.note-title-area {
  border: none;
  font-size: 20px;
  margin-bottom: 10px;
}

.note-body-area {
  min-height: 200px;
  max-height: 300px;
  border: none;
}

.note-content:focus {
  outline: none;
}

.add-note-btn {
  background: transparent;
  margin-left: 1em;
  margin-bottom: 1em;
  border: none;
  color: black;
  cursor: text;
}

.delete-note {
  position: absolute;
  right: 0;
  top: 0;
}

.note-last-update {
  float: left;
  left: 10px;
  position: absolute;
  color: lightslategray;
}

.note-pre-loader {
  background: url("../assets/loader-rolling.svg") no-repeat;
  height: 50px;
  width: 50px;
  margin-top: 2em;
  background-size: contain;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/listingDealNotes.vue